module.exports = __webpack_public_path__ + "static/media/icons8-twitter.37caa662.svg";